import styled from '@emotion/styled';

interface TabButtonProps {
	isActive?: boolean; // isActive를 선택적 prop으로 정의
}
export const MainWrapper = styled.main`
	padding-top: 0px;
	position: relative;
	.container {
		width: 100%;
		position: relative;
	}
`;
export const MainBanner = styled.article`
	padding: 0;
	min-height: 50rem;
	height: min(88rem, 85vh);
	color: #fff;
	position: relative;
	@media screen and (max-width: 900px) {
		height: min(50rem, 70vh);
		min-height: 42rem;
	}
	.swiper {
		width: 100%;
		height: 100%;
	}

	@keyframes heroTitleReveal {
		from {
			opacity: 0;
			transform: translateY(2rem);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes heroDescriptionReveal {
		from {
			opacity: 0;
			transform: translateY(1.4rem);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
	.swiper-slide {
		width: 100% !important;
		height: 100% !important;
		position: relative;
	}
	.img_container {
		position: relative;
		width: 100%;
		height: 100%;
		&::after {
			content: '';
			position: absolute;
			inset: 0;
			background: linear-gradient(90deg, rgba(0, 21, 52, 0.62) 0%, rgba(0, 21, 52, 0.4) 45%, rgba(0, 21, 52, 0.24) 100%);
			pointer-events: none;
		}
	}
	.background {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.textBoxWrapper {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		width: 100%;
		z-index: 10;
		padding: calc(${(props) => props.theme.heights.header} + 2rem) 0 8rem;
		@media screen and (max-width: 1180px) {
			padding: calc(${(props) => props.theme.heights.headerMobile} + 2rem) 0 6rem;
		}
	}
	.textBox {
		display: flex;
		flex-direction: column;
		gap: 2rem;
		max-width: ${(props) => props.theme.scale.contentMaxWidth};
		width: 100%;
		margin: 0 auto;
		padding: 0 ${(props) => props.theme.scale.contentPaddingX};
		filter: drop-shadow(0 8px 24px rgba(0, 21, 52, 0.35));
		.title {
			color: #fff;
			font-size: 6.4rem;
			font-weight: ${(props) => props.theme.fontWeight.weightBold};
			line-height: ${(props) => props.theme.ui.lineHeight.display};
			letter-spacing: ${(props) => props.theme.ui.letterSpacing.tight};
			align-self: stretch;
			max-width: 96rem;
			text-shadow: 0 6px 32px rgba(0, 21, 52, 0.62);
			@media screen and (max-width: 900px) {
				font-size: 3.4rem;
			}
		}
		.description {
			font-size: ${(props) => props.theme.fontSize.size3xl};
			font-weight: ${(props) => props.theme.fontWeight.weightSemi};
			line-height: 1.55;
			letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
			max-width: 78rem;
			color: rgba(255, 255, 255, 0.92);
			text-shadow: 0 4px 24px rgba(0, 21, 52, 0.58);
			@media screen and (max-width: 900px) {
				font-size: ${(props) => props.theme.fontSize.sizeXl};
			}
		}

		.title,
		.description {
			opacity: 0;
		}
		.pagination-container {
			margin-top: 2rem;
		}
	}

	.swiper-slide-active .textBox {
		.title {
			animation: heroTitleReveal 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
		}

		.description {
			animation: heroDescriptionReveal 0.75s cubic-bezier(0.22, 1, 0.36, 1) 0.16s forwards;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.textBox .title,
		.textBox .description {
			opacity: 1;
			animation: none !important;
			transform: none !important;
		}
	}
	.swiper-pagination_custom {
		position: absolute;
		bottom: 3.2rem;
		left: 0;
		right: 0;
		display: flex;
		max-width: ${(props) => props.theme.scale.contentMaxWidth};
		width: 100%;
		margin: 0 auto;
		z-index: 10;
		@media screen and (max-width: 900px) {
			bottom: 2.4rem;
		}
		.swiper-pagination {
			gap: 2.2rem;
			padding: 0 ${(props) => props.theme.scale.contentPaddingX};
			display: flex;
		}
	}
	.swiper-pagination-bullet {
		width: 1rem;
		height: 1rem;
		background: rgba(255, 255, 255, 0.5);
		opacity: 1;
		display: inline-block;
		border-radius: ${(props) => props.theme.effects.radiusFull};
		transition: all ${(props) => props.theme.effects.transitionBase};
		border: 2px solid rgba(255, 255, 255, 0.6);
		margin: 0 !important;
	}
	.swiper-pagination-bullet-active {
		width: 2.8rem;
		border-radius: ${(props) => props.theme.effects.radiusFull};
		background: ${(props) => props.theme.colors.primary400};
		border-color: #fff;
	}
	.swiper-button-next,
	.swiper-button-prev {
		display: none;
	}
`;
export const Description = styled.section`
	padding: ${(props) => props.theme.scale.sectionPaddingY} 0;
	margin: 0 auto;
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	width: 100%;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.spaceXl};
	@media screen and (max-width: ${(props) => props.theme.scale.contentBreakpoint}) {
		padding: ${(props) => props.theme.scale.sectionPaddingY} ${(props) => props.theme.scale.contentPaddingX};
	}
	@media screen and (max-width: 900px) {
		padding: ${(props) => props.theme.scale.sectionPaddingYMobile} ${(props) => props.theme.scale.contentPaddingX};
	}
	.main_description_title {
		color: ${(props) => props.theme.colors.grayDarker};
		text-align: center;
		display: flex;
		flex-direction: column;
		gap: 1.6rem;
		@media screen and (max-width: 900px) {
			text-align: left;
		}
		.description_title {
			font-size: ${(props) => props.theme.fontSize.size6xl};
			font-weight: ${(props) => props.theme.fontWeight.weightBold};
			line-height: ${(props) => props.theme.ui.lineHeight.heading};
			letter-spacing: ${(props) => props.theme.ui.letterSpacing.tight};
			@media screen and (max-width: 900px) {
				font-size: ${(props) => props.theme.fontSize.size4xl};
			}
		}
		.description_sub_title {
			font-size: ${(props) => props.theme.fontSize.sizeXl};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			line-height: ${(props) => props.theme.ui.lineHeight.body};
			letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
			color: ${(props) => props.theme.colors.grayMid};
			@media screen and (max-width: 660px) {
				br {
					display: none;
				}
			}
		}
	}
`;
export const SectionEyebrow = styled.span`
	display: inline-flex;
	align-self: center;
	padding: 0.6rem 1.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.label};
	text-transform: uppercase;
	color: ${(props) => props.theme.colors.primary400};
	background-color: ${(props) => props.theme.colors.primary50};
	border-radius: ${(props) => props.theme.effects.radiusFull};
	@media screen and (max-width: 900px) {
		align-self: flex-start;
	}
`;

export const CardList = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-auto-rows: 1fr;
	gap: 2rem;
	@media screen and (max-width: 1100px) {
		grid-template-columns: repeat(2, 1fr);
		gap: 1.6rem;
	}
	@media screen and (max-width: 420px) {
		grid-template-columns: repeat(1, 1fr);
		gap: 1.2rem;
	}
`;
export const CardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	order: 2;
`;
export const CardTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.size2xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
	display: flex;
	align-items: center;
	gap: 0.8rem;
`;
export const ImgBox = styled.div`
	display: flex;
	max-width: 7.2rem;
	img {
		width: 100%;
		transition: transform ${(props) => props.theme.effects.transitionBase};
	}
`;
export const ImgBoxWrapper = styled.div`
	@media screen and (max-width: 900px) {
		display: flex;
		justify-content: flex-start;
	}
`;
export const CardSubTitle = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: ${(props) => props.theme.colors.grayMid};
`;

export const SpecialTitle = styled.p`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	background: none;
	color: ${(props) => props.theme.colors.grayDarker};
	@media screen and (max-width: 900px) {
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
`;
export const LogoGrid = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	&.mobile {
		grid-template-columns: repeat(2, 1fr);
	}
`;
export const LogoImgWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 13rem;
	padding: 3.2rem 8rem;
	border: 1px solid #e9ecef;
	box-sizing: border-box;
	&.mobile {
		@media screen and (max-width: 600px) {
			padding: 1.6rem 4rem;
			height: 6.4rem;
		}
		@media screen and (min-width: 601px) and (max-width: 1100px) {
			padding: 2.4rem 6rem;
			height: 8.8rem;
		}
	}
`;
export const LogoImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
	&.mobile {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
`;
export const Notice = styled.section`
	padding: ${(props) => props.theme.scale.sectionPaddingY} 0;
	background-color: ${(props) => props.theme.colors.gray};
	@media screen and (max-width: ${(props) => props.theme.scale.contentBreakpoint}) {
		padding: ${(props) => props.theme.scale.sectionPaddingY} ${(props) => props.theme.scale.contentPaddingX};
	}
	@media screen and (max-width: 900px) {
		padding: ${(props) => props.theme.scale.sectionPaddingYMobile} ${(props) => props.theme.scale.contentPaddingX};
	}
	.content {
		padding: 2rem;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
	}
`;
export const NoticeList = styled.ul`
	display: flex;
	flex-direction: column;
	padding: 0.8rem 2.4rem 2rem;
	.last {
		border-bottom: none;
	}
`;
export const NoticeEmptyBox = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 38rem;
	@media screen and (max-width: 900px) {
		min-height: 32rem;
	}
`;
export const NoData = styled.p`
	width: 100%;
	height: 100%;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	text-align: center;
`;
export const NoticeListItem = styled.li`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	padding: 1.6rem 0;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	line-height: ${(props) => props.theme.ui.lineHeight.body};
	border-bottom: 1px solid ${(props) => props.theme.colors.gray100};
	cursor: pointer;
	transition:
		background-color ${(props) => props.theme.effects.transitionFast},
		padding-left ${(props) => props.theme.effects.transitionBase};

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		padding-left: 0.8rem;
		background-color: ${(props) => props.theme.colors.primary50};

		.title {
			color: ${(props) => props.theme.colors.primary400};
		}
	}

	.title {
		color: ${(props) => props.theme.colors.grayDarker};
		font-weight: ${(props) => props.theme.fontWeight.weightMedium};
		transition: color ${(props) => props.theme.effects.transitionFast};
	}
	.sub_title {
		color: ${(props) => props.theme.colors.grayLight};
		font-size: ${(props) => props.theme.fontSize.sizeSm};
	}
`;
export const Divider = styled.div`
	width: 1px;
	height: 29px;
	background-color: #dee2e6;
	margin: 0 1.6rem;
`;
export const EmptyEl = styled.div``;
export const NoticeContent = styled.div`
	margin: 0 auto;
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${(props) => props.theme.scale.spaceMd};
`;
export const NoticeContentList = styled.div`
	display: flex;
	gap: 3.2rem;
	justify-content: space-between;
	width: 100%;
	@media screen and (max-width: 900px) {
		flex-direction: column;
	}
`;
export const CardImg = styled.div<{ bgImg: string }>`
	background-image: linear-gradient(0deg, rgba(0, 21, 52, 0.65) 0%, rgba(18, 83, 158, 0.45) 100%), url(${(props) => props.bgImg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	background-clip: content-box;
	background-origin: content-box;
	position: relative;
	display: flex;
	border-radius: 1.6rem;
	flex: 1;
	min-height: 41rem;
	max-height: 45rem;
	width: 100%;
	cursor: pointer;
	box-shadow:
		0px 0px 4px 0px rgba(0, 0, 0, 0.06),
		4px 8px 8px 0px rgba(0, 0, 0, 0.02),
		12px 8px 24px 0px rgba(0, 0, 0, 0.1);
	.title_box {
		display: flex;
		flex-direction: column;
		gap: 1.2rem;
		position: absolute;
		top: 50%;
		left: 3rem;
		transform: translateY(-50%);
		@media screen and (max-width: 900px) {
			right: 3rem;
		}
		.title {
			color: #fff;
			font-size: 4rem;
			font-weight: 700;
			line-height: ${(props) => props.theme.ui.lineHeight.heading};
			letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
			@media screen and (max-width: 900px) {
				font-size: 3.2rem;
			}
		}
		.sub_title {
			color: #fff;
			font-size: 1.8rem;
			font-weight: 400;
			line-height: ${(props) => props.theme.ui.lineHeight.heading};
			letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
		}
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 1.6rem;
	}
`;
export const NoticeButtonTab = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;
export const ButtonList = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
export const TabButton = styled.div<TabButtonProps>`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => (props.isActive ? props.theme.fontWeight.weightBold : props.theme.fontWeight.weightSemi)};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
	background: none;
	color: ${(props) => (props.isActive ? props.theme.colors.primary400 : props.theme.colors.gray200)};
	border: none;
	cursor: pointer;
	transition: color ${(props) => props.theme.effects.transitionFast};
	@media screen and (max-width: 900px) {
		font-size: ${(props) => props.theme.fontSize.size3xl};
	}
`;
export const NoticeTabList = styled.div`
	display: flex;
	gap: 3.2rem;
`;
export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	@media screen and (max-width: 900px) {
		width: 100%;
		gap: 2.4rem;
		flex-direction: column;
	}
`;
export const GotoButton = styled.button`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	gap: 0.8rem;
	padding: 1rem 1.6rem;
	border: 1px solid ${(props) => props.theme.colors.gray100};
	border-radius: ${(props) => props.theme.effects.radiusFull};
	background: #fff;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: ${(props) => props.theme.colors.grayMid};
	cursor: pointer;
	box-shadow: ${(props) => props.theme.effects.shadowSm};
	transition:
		background-color ${(props) => props.theme.effects.transitionFast},
		border-color ${(props) => props.theme.effects.transitionFast},
		color ${(props) => props.theme.effects.transitionFast},
		box-shadow ${(props) => props.theme.effects.transitionFast};

	&:hover {
		background-color: ${(props) => props.theme.colors.primary400};
		border-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
		box-shadow: ${(props) => props.theme.effects.shadowMd};
	}

	@media screen and (max-width: 900px) {
		align-self: flex-end;
	}
`;
export const Company = styled.div`
	padding: 8rem 0;
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	@media screen and (max-width: ${(props) => props.theme.scale.contentBreakpoint}) {
		padding-left: 2rem;
	}
	.title {
		font-size: ${(props) => props.theme.fontSize.size4xl};
		font-weight: ${(props) => props.theme.fontWeight.weightSemi};
		line-height: ${(props) => props.theme.ui.lineHeight.heading};
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
		color: #212529;
	}
	.swiper {
		--swiper-space-between: 16px;
	}
	.swiper-wrapper {
	}
	.swiper-slide {
		width: unset;
		height: 14.7rem;
		/* height: 16.2rem; */
	}
	.swiper-button-prev {
		right: 4.6rem;
		top: unset;
		bottom: 0;
		left: unset;
		color: #868e96;
		@media screen and (max-width: 900px) {
			right: 6.6rem;
		}
	}
	.swiper-button-next {
		right: 0rem;
		top: unset;
		bottom: 0;
		color: #868e96;
		@media screen and (max-width: 900px) {
			right: 2rem;
		}
	}
	.swiper-button-prev::after {
		color: var(--color-base-white);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
	}
	.swiper-button-next::after {
		color: var(--color-base-white);
		font-size: var(--font-s-small);
		font-weight: var(--font-w-light);
		line-height: 1.551rem;
	}
`;
export const CompanyCard = styled.div<{ padding?: boolean; division?: 'width' | 'height' }>`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 1.6rem;
	background-color: #f8f9fa;
	border: 1px solid #dee2e6;
	width: 21.2rem;
	height: 9.1rem;
	overflow: hidden;
	padding: ${(props) => (props.padding ? '3.2rem' : '1.2rem')};
	cursor: pointer;
	img {
		width: ${(props) => (props.division === 'width' ? 'auto' : '100%')};
		height: ${(props) => (props.division === 'width' ? '100%' : 'auto')};
		display: block;
	}
`;
